export default "__VITE_ASSET__84148bb7__"